<template>
  <div class="hd_diagramm" v-if="loaded">
    <div class="fourcol">
      <div class="col0">
        <h6>Quartal</h6>
        <Dropdown
          v-model="quartal"
          :options="quartalOptions"
          panelClass="hd_dropdown_panel"
        />
      </div>
      <div class="col1">
        <h6>Thema</h6>
        <Dropdown
          v-model="thema"
          :options="themaOptions"
          panelClass="hd_dropdown_panel"
        />
      </div>
      <div class="col2">
        <Button @click="$emit('download-pdf')">Als PDF herunterladen</Button>
      </div>
    </div>
    <div class="hd_maincol">
      <div class="hd_charts_wrapper">
        <div class="chartleft_wrapper chart_wrapper" v-if="chartLeft.chartData">
          <HnBar
            :options="chartLeft.chartOptions"
            :data="chartLeft.chartData"
            id="chartleft"
            :title="`${thema} ${quartal}`"
          />
        </div>
        <div
          class="chartcenter_wrapper chart_wrapper"
          v-if="chartCenter.chartData"
        >
          <HnBar
            :options="chartCenter.chartOptions"
            :data="chartCenter.chartData"
            id="chartcenter"
            title="Vorjahresquartal (VJQ)"
          />
        </div>
        <div
          class="chartright_wrapper chart_wrapper"
          v-if="chartRight.chartData"
        >
        <!-- <h3>Veränderung zum VJQ</h3>
        <div class="tablewrapper">
          <div v-for="row in chartRight.chartData.datasets[0].data" key="row">{{ row }}</div>
        </div> -->
     <HnBar
            :options="chartRight.chartOptions"
            :data="chartRight.chartData"
            id="chartright"
            title="Veränderung zum VJQ"
          />
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import HnBar from "@/components/hd/HnBar";
import useReadSheet from "@/composables/useReadSheet.js";
import {
  defaultGraphSettings,
  hnLeftSettings,
  hnCenterSettings,
  hnRightSettings,
} from "@/utils/settings.js";

export default {
  name: "HonorarDiagramm",
  props: ["file", "inPrint", "inDownload"],
  components: { Dropdown, HnBar, Button },
  emits: ['download-pdf'],
  setup(props, { emit }) {
    const sheetData = ref(null);
    const quartal = ref(null);
    const thema = ref(null);
    const filteredRows = ref(null);
    const themaOptions = ref([]);
    const quartalOptions = ref([]);
    const loaded = ref(false);
    const inPrint = ref(false);
    let orChartLabels = null;
    let chartLabels = null;

    const chartLeft = ref({
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        ...hnLeftSettings,
      },
    });

    const chartCenter = ref({
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        ...hnCenterSettings,
      },
    });

    const chartRight = ref({
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        ...hnRightSettings,
      },
    });

    const loadData = async () => {
      const dataUp = await useReadSheet(
        props.file,
        ["Honorar"],
        ["Honorar:0", "Honorar:1"]
      );

      // Update refs
      sheetData.value = dataUp;
      quartal.value = dataUp.selectLists[0].reverse()[0];
      thema.value = dataUp.selectLists[1].reverse()[0];
      quartalOptions.value = Object.values(dataUp.selectLists[0]);
      themaOptions.value = dataUp.selectLists[1].reverse();
      loaded.value = true;
      //Update rows
      updateFilteredRows();
    };

    loadData();

    const updateChartSigns = () => {
      const chartSign = thema.value.substr(0, 3) == "Aus" ? "%" : "€";
      chartLeft.value.chartOptions.plugins.datalabels.formatter = (
        value,
        context
      ) => {
        return (
          Math.round(value).toLocaleString("de-DE", {
            minimumFractionDigits: 0,
          }) +
          chartSign
        );
      };

      chartLeft.value.chartOptions.plugins.tooltip.callbacks.label = (
        context
      ) => {
        return (
          Math.round(context.raw).toLocaleString("de-DE", {
            minimumFractionDigits: 0,
          }) +
          chartSign
        );
      };

      chartLeft.value.chartOptions.plugins.tooltip.callbacks.title = (
        context
      ) => {
       return context[0].label.replace(/,/g,"");
      };

      chartCenter.value.chartOptions.plugins.datalabels.formatter = (
        value,
        context
      ) => {
        return (
          Math.round(value).toLocaleString("de-DE", {
            minimumFractionDigits: 0,
          }) +
          chartSign
        );
      };

      chartCenter.value.chartOptions.plugins.tooltip.callbacks.label = (
        context
      ) => {
        return (
          Math.round(context.raw).toLocaleString("de-DE", {
            minimumFractionDigits: 0,
          }) +
          chartSign
        );
      };
    };

    

    chartCenter.value.chartOptions.plugins.tooltip.callbacks.title = (
        context
      ) => {
       return context[0].label.replace(/,/g,"");
      };

      chartRight.value.chartOptions.plugins.tooltip.callbacks.title = (
        context
      ) => {
       return context[0].label.replace(/,/g,"");
      };

    const updateFilteredRows = () => {
      const rowsAr = Object.values(
        sheetData.value.rowData.Honorar.filter((v) => {
          if (v[0] == quartal.value && v[1] == thema.value) {
            return v;
          }
        })
      );
      rowsAr.sort((a, b) => {
        if (a[3] === b[3]) {
          return 0;
        } else {
          return a[3] < b[3] ? -1 : 1;
        }
      });
      filteredRows.value = rowsAr;
      updateChartSigns();
    };

    const breakStringForLabel = (str) => {
      return str.length > 35 ? str.match(/.{0,35}(\s|$)/g) : str;
    };

    const parseDataForTables = () => {
      const chartLeftData = filteredRows.value.map((v) => v[4]);
      const chartLeftLabels = filteredRows.value.map((v) => {
        return breakStringForLabel(v[3]);
      });
      const chartPopupLabels = filteredRows.value.map((v) => v[3]);
      chartLeft.value.chartData.datasets = [
        { data: chartLeftData, minBarLength: 3 },
      ];
      chartLeft.value.chartData.labels = chartLeftLabels;
      chartLabels = chartLeftLabels;

      const chartCenterData = filteredRows.value.map((v) => v[5]);
      chartCenter.value.chartData.datasets = [
        { data: chartCenterData, minBarLength: 3,  hoverBackgroundColor: '#021121'},
      ];
      chartCenter.value.chartData.labels = chartLeftLabels;

     // const chartRightData = filteredRows.value.map((v) => (Math.round(v[6] * 10) / 10).toLocaleString("de-DE") + "%");
      const chartRightData = filteredRows.value.map((v) => v[6]);
      chartRight.value.chartData.datasets = [
        { data: chartRightData, minBarLength: 3,  hoverBackgroundColor: '#304052' },
      ];
      chartRight.value.chartData.labels = chartLeftLabels;
    };

    watch(
      () => filteredRows.value,
      (val, prevVal) => {
        parseDataForTables();
      }
    );

    watch(
      () => quartal.value,
      (val, prevVal) => {
        updateFilteredRows();
      }
    );
    watch(
      () => thema.value,
      (val, prevVal) => {
        updateFilteredRows();
      }
    );

    watch(
      () => props.inDownload,
      (val, prevVal) => {
        
        if (val) {
          chartLeft.value.chartOptions.animation = false;
          chartCenter.value.chartOptions.animation = false;
          chartRight.value.chartOptions.animation = false;
          //chartLeft.value.chartData.labels = orChartLabels;
        } else {
          chartLeft.value.chartOptions.animation = true;
          chartCenter.value.chartOptions.animation = true;
          chartRight.value.chartOptions.animation = true;
        }
      }
    );

    watch(
      () => props.inPrint,
      (val, prevVal) => {
        if (val) {
          chartLeft.value.chartOptions.animation = false;
          chartCenter.value.chartOptions.animation = false;
          chartRight.value.chartOptions.animation = false;
          chartLeft.value.chartOptions.scales.y.ticks.font.size = 10;
          
          // chartLeft.value.chartOptions.barThickness = 6;
          // chartRight.value.chartOptions.barThickness = 6;
          // chartCenter.value.chartOptions.barThickness = 6;
        } else {
          chartLeft.value.chartOptions.animation = true;
          chartCenter.value.chartOptions.animation = true;
          chartRight.value.chartOptions.animation = true;
          chartLeft.value.chartOptions.scales.y.ticks.font.size = 13;
          // chartLeft.value.chartOptions.barThickness = 10;
          // chartRight.value.chartOptions.barThickness = 10;
          // chartCenter.value.chartOptions.barThickness = 10;
        }
      }
    );

    return {
      sheetData,
      chartLeft,
      chartCenter,
      chartRight,
      thema,
      quartal,
      themaOptions,
      quartalOptions,
      loaded,
    };
  },
};
</script>

<style lang="scss"></style>
